import React from 'react';
import StripeProvider from './StripeProvider';
import HobexProvider from './HobexProvider';
import FiasProvider from './FiasProvider';
import AsaProvider from './AsaProvider';
import ApaleoProvider from './ApaleoProvider';
import MewsProvider from './MewsProvider';
import CasablancaProvider from './CasablancaProvider';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Folio} from "crqlar-react-common/models/billing/folio.model";

interface ProviderFactoryProps {
    provider: string;
    onDataChange: (isValid: boolean, data: any) => void;
    profileId?: string;
    folio?: Folio;
    /**
     * The folio dialog's payment block, beside its totals: small fields, less space, no title repeating
     * the chosen payment method. Without it (the legacy dialogs) the forms are as they always were.
     */
    compact?: boolean;
}

const ProviderFactory = ({provider, onDataChange, profileId, folio, compact}: ProviderFactoryProps) => {
    const {t} = useTranslation();

    switch (provider.toLowerCase()) {
        case 'stripe':
            return <StripeProvider onDataChange={onDataChange} profileId={profileId} folio={folio} compact={compact}/>;
        case 'hobex':
            return <HobexProvider onDataChange={onDataChange} profileId={profileId} folio={folio} compact={compact}/>;
        case 'fias':
            return <FiasProvider onDataChange={onDataChange} profileId={profileId} compact={compact}/>;
        case 'asa':
            return <AsaProvider onDataChange={onDataChange} profileId={profileId} compact={compact}/>;
        case 'apaleo':
            return <ApaleoProvider onDataChange={onDataChange} profileId={profileId} compact={compact}/>;
        case 'mews':
            return <MewsProvider onDataChange={onDataChange} profileId={profileId} folio={folio} compact={compact}/>;
        case 'casablanca':
            return <CasablancaProvider onDataChange={onDataChange} profileId={profileId} compact={compact}/>;
        default:
            return (
                <Box sx={{padding: compact ? 0 : 2}}>
                    <Typography color="error" sx={compact ? {fontSize: 13} : undefined}>
                        {t('Unknown provider: {{provider}}', {provider})}
                    </Typography>
                </Box>
            );
    }
};

export default ProviderFactory;